export const CONSTANTS = {
	RESETALL: Symbol("Attendees/ResetAll"),
	SORTING_SCAN: "with_scans",
	ASC: "ascending",
	DESC: "descending",
	nextLink: "Link"
};

const initialState = {
	attendee: null,
	attendees: null,
	nextCursor: null,
	ordering: {
		column: "last_name",
		direction: CONSTANTS.ASC
	},
	isLoading: {
		all: false,
		scan: false
	},
	isReordering: false
};
/**
 * Reducer managing contingent.
 *
 * @name AttendeeReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		switch (action.type) {
			case CONSTANTS.RESETALL:
				return initialState;
			default:
				return state;
		}
	}

	return action.performAttendeeReducer(state);
};
